import { isEmpty, join } from "lodash-es";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { push } from "../../utils/navigation";
import { withRouter } from "../../utils/withRouter";
import { Card } from "reactstrap";
import { saveNewOilRequest } from "../../actions/clientRequestsActions";
import { BASE_URL, isNullEmptyOrWhitespace } from "../../constants";
import { mustBeArray, requestHasError } from "../../utils";
import { apiRequest } from "../../utils/request";
import NewOilRequestForm from "./NewOilRequestForm";
import { listClientLocations } from "../../actions/homeActions";

const title =
  "Are you looking for a cooking oil solution? Talk to us about your cooking oil needs today.";
const NewOilRequest = ({ dispatch, userId, clientLocationsDelivery, locationId }) => {
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    otherInformation: "",
    phoneNumber: "",
    locations: [],
    emailAddress: "",
    clientId: null,
  });
  const [clientNameList, setClientNameList] = useState([]);
  const [clientLocationList, setClientLocationList] = useState([]);
  const [allLocationList, setAllLocationList] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);

  useEffect(() => {
    dispatch(listClientLocations('Fresh Oil', locationId));
    loadUserDetails();
  }, [locationId]);

  useEffect(()=>{
    if(clientLocationsDelivery && clientLocationsDelivery.length > 0){
      if(locationId){
        dispatch(push(`${BASE_URL}/request-oil-delivery/${locationId}`));
      } else {
        dispatch(push(`${BASE_URL}/request-oil-delivery`));  
      }      
    }
  },[clientLocationsDelivery, locationId]);

  const loadUserDetails = () => {
    apiRequest(`/api/users/${userId}`).then((x) => {
      const data = x.data || {};
      const locations = mustBeArray(data.authorisationRequests).filter(
        (o) => o.toLocationId
      );
      let clients = mustBeArray(data.authorisationRequests).filter(
        (o) => o.toClientId
      );
      const phone = getPhoneNumber(data.userContact.communications);
      setValues({
        ...values,
        firstName: data.userContact && data.userContact.firstName,
        lastName: data.userContact && data.userContact.lastName,
        emailAddress: data.userName,
        phoneNumber: phone,
      });
      // Fetch location details to find their client id
      const q = join(locations.map(m => m.toLocationId), `&locationIds=`);
      apiRequest(`/api/managelocations?locationIds=${q}`).then(x => {
        let locationData = mustBeArray(x.data);
        locationData = locationData.reduce((a,b) => {
          if(!clients.find(o => o.toClientId === b.clientId)){
            clients = [...clients, {toClientId: b.clientId, toClientName: b.clientCompanyName}];
          }
          return ([...a, {toLocationId: b.id, toLocationName: b.locationName, clientId: b.clientId}]);
        },[]);
        setAllLocationList(locationData); 
        setClientNameList(clients);
        if(clients.length === 1){
          // Default select the client if only one present
          const defaultClient = clients[0].toClientId;
          setValues({...values, clientId: defaultClient});
          const filteredLocations = locationData.filter(o => defaultClient);
          setClientLocationList(filteredLocations);
        } 
      });
    });
  };

// Find primary contact with phone number and if it doesn't exist fine a contact with phone number
  const getPhoneNumber = (communications) => {
    const primaryContact = communications.find(
      (o) =>
        o.isPrimary &&
        o.communicationType &&
        o.communicationType.includes("Phone")
    );
    if (primaryContact) return primaryContact.detail;
    const mobileContact = communications.find(
      (o) => o.communicationType && o.communicationType.includes("Phone")
    );
    if (mobileContact) return mobileContact.detail;
    return "";
  };

  const handleLocationChange = ({ id }) => {
    let newSelectedLocationList;
    if (values.locations.includes(id)) {
      newSelectedLocationList = values.locations.filter((o) => o !== id);
    } else {
      newSelectedLocationList = [...values.locations, id];
    }
    setValues({ ...values, locations: newSelectedLocationList });
  };

  const handleSave = () => {
    if (!values.firstName) {
      return toastr.error("First Name is required.");
    }
    if (!values.lastName) {
      return toastr.error("Last Name is required.");
    }
    if (!values.emailAddress) {
      return toastr.error("Email Address is required.");
    }
    if (isEmpty(values.locations)) {
      return toastr.error("Please select a location.");
    }
    if (isNullEmptyOrWhitespace(values.clientId)) {
      return toastr.error("Please select a client name.");
    }
    setSaveLoading(true);
    const locations = mustBeArray(values.locations).reduce((a,b) => {
      return [...a, {locationId: b}];
    },[]);
    dispatch(saveNewOilRequest({ payLoad: {...values, locations} })).then((x) => {
      setSaveLoading(false);
      if (!requestHasError({ x })) {
        toastr.success("New Oil request created.");
        dispatch(push(`${BASE_URL}/`));
      }
    });
  };
  const handleFieldChange = (e) => { 
    if(e===null){
      setClientLocationList( []);
      return setValues({...values, clientId: null});
    }
    if (e.toClientId) {
      setValues({ ...values, clientId: e.toClientId,locations:[] });
      const filteredLocations = allLocationList.filter(o => o.clientId === e.toClientId);
      setClientLocationList(filteredLocations);
    } else {
      setValues({ ...values, [e.currentTarget.name]: e.currentTarget.value });
    }
  };

  return (
    <React.Fragment>
      <div className={"row"}>
        <div className={"col-12"} style={{ marginBottom: "24px" }}>
          <h4>New Oil Request</h4>
        </div>
      </div>

      <Card className="p-1">
        <div className="font-weight-semibold mb-h">{title}</div>
        <div className="font-weight-semibold mb-1">
          To get started, fill in the form below:
        </div>
        <NewOilRequestForm
          values={values}
          clientNameList={clientNameList}
          locationList={clientLocationList}
          handleLocationChange={handleLocationChange}
          handleSave={handleSave}
          handleFieldChange={handleFieldChange}
          saveLoading={saveLoading}
        />
      </Card>
    </React.Fragment>
  );
};

function mapStateToProps(state, ownProps) {
  const locationId = parseInt(ownProps.routeParams.locationId);
  return {
    userId: state.account && state.account.user && state.account.user.id,
    clientLocationsDelivery: state.home && state.home.clientLocationsDelivery,   
    locationId: isNaN(locationId) ? null : locationId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewOilRequest));
